type ResolvePublicAssetUrlPayload = {
  relativePath: string;
};

const normalizeRelativeAssetPath = ({
  relativePath,
}: ResolvePublicAssetUrlPayload): string => {
  return relativePath.replace(/\\/g, "/").replace(/^\/+/, "");
};

export const resolvePublicAssetUrl = ({
  relativePath,
}: ResolvePublicAssetUrlPayload): string => {
  const normalizedPath = normalizeRelativeAssetPath({ relativePath });
  const basePath = import.meta.env.BASE_URL ?? "/";
  const normalizedBasePath = basePath.endsWith("/") ? basePath : `${basePath}/`;
  return `${normalizedBasePath}${normalizedPath}`;
};
